module.exports = __webpack_public_path__ + "static/media/square-events.be17ab81.jpg";